import { FileUploadItem } from "./FileUploadItem";
import React from "react";
import List from "@mui/material/List";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LoadingButton from "@mui/lab/LoadingButton";
import { UploadComponent } from "./form/DragDropUploadComponent";
import { Stack, Typography } from "@mui/material";

export default function MultiFileUpload({
  values,
  setFieldValue,
  isSubmitting,
  filePurposes,
}) {
  return (
    <Stack spacing={1}>
      <UploadComponent
        setFieldValue={setFieldValue}
        fieldName="filesToUpload"
      />
      {values?.filesToUpload.length > 0 && (
        <>
          <Typography variant="subtitle">Files To Upload</Typography>
          <List dense={true}>
            {values.filesToUpload.map(({ name, size, type }, index) => (
              <FileUploadItem
                key={index}
                index={index}
                name={name}
                type={type}
                size={size}
                filePurposes={filePurposes}
              />
            ))}
          </List>

          <Stack direction="row-reverse">
            <LoadingButton
              type="submit"
              loading={isSubmitting}
              loadingPosition="start"
              startIcon={<FileUploadIcon />}
              variant="contained"
              color="primary"
              size="small"
              margin="normal"
            >
              Upload File{values.filesToUpload.length > 1 ? "s" : ""}
            </LoadingButton>
          </Stack>
        </>
      )}
    </Stack>
  );
}
